class $a8f5238e28f8bd2b$var$Map {
    _parentElement = document.querySelector("#map");
    #map;
    createMap(lat, lng) {
        this.#map = L.map("map", {
            dragging: false,
            doubleClickZoom: false,
            scrollWheelZoom: false,
            zoomControl: false
        }).setView([
            lat,
            lng
        ], 13);
        L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
            maxZoom: 19,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        }).addTo(this.#map);
    }
    _clear() {
        this._parentElement.innerHTML = "";
    }
    moveMap(lat, lng) {
        this.#map.setView([
            lat,
            lng
        ], 13, {
            animate: true,
            pan: {
                duration: 1
            }
        });
    }
}
var $a8f5238e28f8bd2b$export$2e2bcd8739ae039 = new $a8f5238e28f8bd2b$var$Map();


const $ba30e20475feac5a$export$a9861bd62f48e142 = "at_rDTD1SSL0UoUjymbUcUC2WAotcpYY";
const $ba30e20475feac5a$export$923ea8233b386e99 = "https://geo.ipify.org/api/v2/country,city?apiKey=";


const $0f1d4402dffacf5b$export$ca000e230c0caa3e = {
    map: {
        coords: [],
        ip: "",
        location: {},
        timezone: "",
        isp: ""
    }
};
const $0f1d4402dffacf5b$var$createMapObject = function(data) {
    const map = data;
    return $0f1d4402dffacf5b$export$ca000e230c0caa3e.map = {
        ip: map.ip,
        isp: map.isp,
        location: {
            country: map.location.country,
            region: map.location.region,
            city: map.location.city,
            lat: map.location.lat,
            lng: map.location.lng,
            timezone: map.location.timezone
        }
    };
};
const $0f1d4402dffacf5b$export$da6cbbdaca000534 = async function(query) {
    try {
        const ipPattern = /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/;
        // Data
        const response = await fetch(`${(0, $ba30e20475feac5a$export$923ea8233b386e99)}${(0, $ba30e20475feac5a$export$a9861bd62f48e142)}&${ipPattern.test(query) ? "ipAddress" : "domain"}=${query}`);
        if (!response.ok) throw new Error("invalid search");
        const data = await response.json();
        // console.log(data);
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.map = $0f1d4402dffacf5b$var$createMapObject(data);
    // console.log(state);
    } catch (err) {
        throw err;
    }
};


class $70c48653cf6e1d65$var$Details {
    _parentElement = document.querySelector(".details--container");
    _data;
    render(data) {
        this._data = data;
        const markup = this._generateMarkup();
        this._parentElement.innerHTML = "";
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    _generateMarkup() {
        return `
        <div
            class="detail--ip-address lg:border-r lg:border-dark-gray flex flex-col"
          >
            <h4 class="text-dark-gray tracking-wider text-sm font-bold lg:mb-2">
              IP ADRESS
            </h4>

            <span class="text-very-dark-gray lg:text-3xl text-xl font-bold whitespace-normal"
              >${this._data.ip}</span
            >
          </div>
          <div
            class="detail--location lg:border-r lg:border-dark-gray flex flex-col"
          >
            <h4 class="text-dark-gray tracking-wider text-sm font-bold lg:mb-2">
              LOCATION
            </h4>

            <span class="text-very-dark-gray lg:text-3xl text-xl font-bold lg:line-clamp-3 line-clamp-1"
              >${this._data.location.city}, ${this._data.location.region}</span
            >
          </div>
          <div
            class="detail--timezone lg:border-r lg:border-dark-gray flex flex-col"
          >
            <h4 class="text-dark-gray tracking-wider text-sm font-bold lg:mb-2">
              TIMEZONE
            </h4>

            <span class="text-very-dark-gray lg:text-3xl text-xl font-bold"
              >${this._data.location.timezone}</span
            >
          </div>
          <div class="detail--ISP flex flex-col ">
            <h4 class="text-dark-gray tracking-wider text-sm font-bold lg:mb-2 ">
              ISP
            </h4>

            <span class="text-very-dark-gray lg:text-3xl text-xl font-bold lg:line-clamp-3 line-clamp-1"
              >${this._data.isp}</span
            >
          </div>
        `;
    }
}
var $70c48653cf6e1d65$export$2e2bcd8739ae039 = new $70c48653cf6e1d65$var$Details();


class $517cf2ae0791ab9c$var$Search {
    _parentElement = document.querySelector(".search");
    _searchBar = document.querySelector(".search-field");
    _btn = document.querySelector(".search--button");
    _errorMessage = document.querySelector(".error-message");
    getQuery() {
        const query = this._parentElement.querySelector(".search-field").value;
        this._parentElement.querySelector(".search-field").value = "";
        return query;
    }
    renderError() {
        this._searchBar.classList.add("border-2", "border-red-500");
        this._errorMessage.classList.remove("hidden");
    }
    clearRenderError() {
        this._searchBar.classList.remove("border-2", "border-red-500");
        this._errorMessage.classList.add("hidden");
    }
    addHandlerSearch(handler) {
        this._btn.addEventListener("click", function(e) {
            e.preventDefault();
            handler();
        });
    }
}
var $517cf2ae0791ab9c$export$2e2bcd8739ae039 = new $517cf2ae0791ab9c$var$Search();


const $f50bd1f2915ed0f2$var$updateMap = async function(ip) {
    await $0f1d4402dffacf5b$export$da6cbbdaca000534(ip);
    // create details
    (0, $70c48653cf6e1d65$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.map);
    // Create the Map
    (0, $a8f5238e28f8bd2b$export$2e2bcd8739ae039).createMap($0f1d4402dffacf5b$export$ca000e230c0caa3e.map.location.lat, $0f1d4402dffacf5b$export$ca000e230c0caa3e.map.location.lng);
};
const $f50bd1f2915ed0f2$var$loadMap = async function() {
    try {
        // IP Address on the initial page load
        const response = await fetch("https://api.ipify.org?format=json");
        const data = await response.json();
        // Update Map
        $f50bd1f2915ed0f2$var$updateMap(data.ip);
    } catch (err) {
        console.error(err);
    }
};
const $f50bd1f2915ed0f2$var$searchMap = async function() {
    try {
        (0, $517cf2ae0791ab9c$export$2e2bcd8739ae039).clearRenderError();
        // 1) take ip address
        const ipAddress = (0, $517cf2ae0791ab9c$export$2e2bcd8739ae039).getQuery();
        await $0f1d4402dffacf5b$export$da6cbbdaca000534(ipAddress);
        // create details
        (0, $70c48653cf6e1d65$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.map);
        // 3) move map
        (0, $a8f5238e28f8bd2b$export$2e2bcd8739ae039).moveMap($0f1d4402dffacf5b$export$ca000e230c0caa3e.map.location.lat, $0f1d4402dffacf5b$export$ca000e230c0caa3e.map.location.lng);
    } catch (err) {
        (0, $517cf2ae0791ab9c$export$2e2bcd8739ae039).renderError();
    }
};
const $f50bd1f2915ed0f2$var$init = function() {
    (0, $517cf2ae0791ab9c$export$2e2bcd8739ae039).addHandlerSearch($f50bd1f2915ed0f2$var$searchMap);
};
$f50bd1f2915ed0f2$var$loadMap();
$f50bd1f2915ed0f2$var$init();


//# sourceMappingURL=index.5193398d.js.map
